import { useCaseDetails } from '@/hooks/useCaseDetails';
import { Case, DraftCase } from '@/api/apis/case';

export const useCaseDetailsSafe = (): (Case | DraftCase) | null => {
  try {
    return useCaseDetails();
  } catch {
    return null;
  }
};
